import { useStationCtx } from '../../containers/StationCtx';
import { Station } from '@app/core/types/stations';

export function useActiveStation({ throwIfMissing }: { throwIfMissing?: boolean } = {}): Station {
  return useStationCtx({ innerThrowIfMissingProvider: throwIfMissing });
}
